/** @format */
import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { OtmId, StudyEvent } from 'common-typescript/types';
import { StudyEvent as GraphQLStudyEvent } from 'sis-common';

@Component({
    selector: 'app-study-event-info',
    templateUrl: './study-event-info.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class StudyEventInfoComponent implements OnChanges {
    @Input() studyEvent: StudyEvent | GraphQLStudyEvent;
    @Input() teacherIds?: OtmId[];

    twoColumns = false;

    ngOnChanges(changes: SimpleChanges): void {
        this.twoColumns = this.teacherIds?.length > 0 || this.studyEvent?.cancellations?.length > 0;
    }

    hasLocations(studyEvent: StudyEvent | GraphQLStudyEvent): studyEvent is GraphQLStudyEvent {
        return 'locations' in studyEvent;
    }
}
